import {mergeDeep} from "./object";

export const updateBy = (collection = [], change = {}, dataIndex = 'id') => {
    return collection?.map(one => (change[dataIndex] === one[dataIndex]) ? mergeDeep(one, change) : one);
};
/**
 *
 * @param text {string}
 * @param collection {string[]}
 * @returns {{fail: number, match: number}}
 */
export const includesEither = (text, collection) => {
    const _text = text?.trim()?.toLowerCase();

    let result = {
        match: 0,
        fail: 0,
    }

    collection.forEach(keyword => {

        const _keyword = keyword?.trim()?.toLowerCase();

        if (_text.includes(_keyword))
            result.match += 1;
        else result.fail += 1

    })

    return result;
}

/**
 *
 * @param array {*[]}
 * @param keyword {string}
 * @param key {string}
 * @returns {*}
 */
export const searchList = (array, keyword, key) => {
    return array
        .map(item => ({
            ...item,
            ...includesEither(String(item[key]), keyword.split(' '))
        }))
        .filter(item => item.match >= 1)
        .sort((a, b) => b.match - a.match)
        .map(({match, fail, ...rest}) => ({...rest}))
}
